import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import Tooltip from "@mui/material/Tooltip";
import Edit from "@mui/icons-material/Edit";
import Chip from "@mui/material/Chip";
import { ActionPlansContext } from "context/ActionPlansContext";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import UserService from "services/UserService";
import { putActionPlan, getActionPlan } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  CustomSelect,
  DateInput,
  TextInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import { planActions } from "variables/planActions";
import { statusData } from "variables/lists/planActions";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    //height: 400,
    marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "60ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export default function GeneralEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanadmin = permis.includes("actionplan_admin");
  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;

  const groupInfoContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = groupInfoContext;

  const [newGeneral, setNewGeneral] = useState({});
  const [groups, setGroups] = useState();
  const [editGroups, setEditGroups] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewGeneral((prevState) => ({
      ...prevState,
      [params]: { ...prevState.general, [name]: value },
    }));
  };

  const handleStatusChange = (e) => {
    const { name, value } = e.target;
    setNewGeneral((prevState) => ({
      ...prevState,
      [params]: {
        ...prevState.general,
        [name]: value,
        lastupdate: new Date().toISOString().slice(0, 10),
      },
    }));
  };

  useEffect(() => {
    setNewGeneral(actionPlans?.parameters || {});
    setGroups(actionPlans?.parameters?.general?.groups || []);
  }, [actionPlans]);

  const urlPlanAction = getActionPlan(actionPlans.id);

  let url = putActionPlan(actionPlans.id);

  const handleSubmit = (event) => {
    createActionGeneral(event);
    //setLoading(true);
  };

  const createActionGeneral = async (event) => {
    const groupsIsAnArray = Array.isArray(groups);
    if (groupsIsAnArray) {
      axios
        .put(
          url,
          {
            ...newGeneral,
            general: { ...newGeneral.general, groups },
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setActionPlans((prevState) => ({
              ...prevState,
              parameters: {
                ...newGeneral,
                general: { ...newGeneral.general, groups },
              },
            }));
            setNotification("success", "Plan d'action modifié");
            getActionPlanData();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          //setLoading(false);
        });
    } else {
      axios
        .put(
          url,
          {
            ...newGeneral,
            general: { ...newGeneral.general, groups: [groups] },
          },
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            setNotification("success", "Plan d'action modifié");
            getActionPlanData();
          } else setNotification("error", "Une erreur est survenue");
        })
        .catch((error) => {
          setNotification("error", "Une erreur est survenue");
          //setLoading(false);
        });
    }
  };

  const getActionPlanData = () => {
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        setActionPlans(response.data || []);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const showEntitesTree = () => {
    setEditGroups((prevCheck) => !prevCheck);
  };

  const classes = useStyles();

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <div style={{ marginLeft: "25px", marginTop: "1rem" }}>
          Périmètre :
          <GroupCell>
            {groups?.map((groupid) => {
              return <Chip label={groupInfoListById[groupid]} key={groupid} />;
            })}
          </GroupCell>
        </div>
      </GridItem>
      <GridItem xs={12} sm={12} md={6} lg={6}>
        <TextInput
          inputTitle={planActions.general.name}
          textInput={newGeneral?.[params]?.name}
          handleTextInputChange={handleChange}
          name="name"
          disabled={!actionplanadmin}
        />
        <DateInput
          inputTitle={planActions.general.lastupdate}
          dateInput={newGeneral?.[params]?.lastupdate}
          handleDateInputChange={handleChange}
          name="lastupdate"
          disabled={!actionplanadmin}
        />

        <DateInput
          inputTitle={planActions.general.prevstartdate}
          dateInput={newGeneral?.[params]?.prevstartdate}
          handleDateInputChange={handleChange}
          name="prevstartdate"
          disabled={!actionplanadmin}
        />
        <DateInput
          inputTitle={planActions.general.realstartdate}
          dateInput={newGeneral?.[params]?.realstartdate}
          handleDateInputChange={handleChange}
          name="realstartdate"
          disabled={!actionplanadmin}
        />
        <TextInput
          inputTitle={planActions.general.personincharge}
          textInput={newGeneral?.[params]?.personincharge}
          handleTextInputChange={handleChange}
          name="personincharge"
          disabled={!actionplanadmin}
        />
        <TextInput
          inputTitle={planActions.general.description}
          textInput={newGeneral?.[params]?.description}
          handleTextInputChange={handleChange}
          name="description"
          multiline
          disabled={!actionplanadmin}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6} lg={6}>
        <TextInput
          inputTitle={planActions.general.code}
          textInput={newGeneral?.[params]?.code}
          handleTextInputChange={handleChange}
          name="code"
          disabled={!actionplanadmin}
        />
        <CustomSelect
          inputTitle={planActions.general.status}
          selectValue={newGeneral?.[params]?.["status"] || ""}
          handleSelectValueChange={handleStatusChange}
          data={statusData}
          name="status"
          disabled={!actionplanadmin}
        />
        <DateInput
          inputTitle={planActions.general.prevenddate}
          dateInput={newGeneral?.[params]?.prevenddate}
          handleDateInputChange={handleChange}
          name="prevenddate"
          disabled={!actionplanadmin}
        />
        <DateInput
          inputTitle={planActions.general.realenddate}
          dateInput={newGeneral?.[params]?.realenddate}
          handleDateInputChange={handleChange}
          name="realenddate"
          disabled={!actionplanadmin}
        />
        <TextInput
          inputTitle={planActions.general.orgincharge}
          textInput={newGeneral?.[params]?.orgincharge}
          handleTextInputChange={handleChange}
          name="orgincharge"
          disabled={!actionplanadmin}
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={6} lg={6}>
        {/*<div
          style={{
            marginTop: "1rem",
          }}
        >
          <Tooltip title="Modifier le périmètre">
            <Button
              onClick={showEntitesTree}
              color={"info"}
              //className={classes.actionButton}
              style={{
                height: "32px",
                width: "32px",
                padding: "0px",
                margin: "0px",
                marginLeft: "5px",
                backgroundColor: "#91C241",
              }}
            >
              <Edit fontSize="large" />
            </Button>
          </Tooltip>
          editGroups ? (
            <div className={classes.treeVisible}>
              <TreeLabel>Choix du périmètre</TreeLabel>
              <ImageList rowHeight={120} className={classes.gridList} cols={1}>
                <EntitesTree selectedIds={setGroups} userSelectedIds={groups} />
              </ImageList>
            </div>
          ) : (
            <>
              Périmètre :
              <GroupCell>
                {groups?.map((groupid) => {
                  return (
                    <Chip label={groupInfoListById[groupid]} key={groupid} />
                  );
                })}
              </GroupCell>
            </>
          )
        </div>*/}
      </GridItem>
      {actionplanadmin && (
        <GridItem
          xs={12}
          sm={6}
          md={7}
          lg={7}
          style={{ marginLeft: "8px", marginTop: "12px" }}
        >
          <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
        </GridItem>
      )}
    </GridContainer>
  );
}
